/**
 * 📦 COMPOSANT : sellerie-app/frontend/src\components\SoNestingLogo.tsx
 * Ce composant est utilisé dans d'autres pages de l'application
 */

import React from 'react';

interface SoNestingLogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showText?: boolean;
  className?: string;
}

const SoNestingLogo: React.FC<SoNestingLogoProps> = ({ 
  size = 'md', 
  showText = true, 
  className = '' 
}) => {
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-12 h-12',
    lg: 'w-16 h-16',
    xl: 'w-24 h-24'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl',
    xl: 'text-4xl'
  };

  return (
    <div className={`flex items-center space-x-3 ${className}`}>
      {/* Logo SVG So-nesting */}
      <div className={`${sizeClasses[size]} so-logo`}>
        <svg 
          viewBox="0 0 80 80" 
          className="w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* Hexagone principal So-nesting */}
          <g transform="translate(40,40)">
            {/* Hexagone contour */}
            <polygon 
              points="-20,0 -10,-17 10,-17 20,0 10,17 -10,17"
              fill="none" 
              stroke="#8C8279" 
              strokeWidth="2.5"
            />
            
            {/* Pièces imbriquées */}
            {/* Pièce gauche (beige) */}
            <rect 
              x="-9" 
              y="-8" 
              width="8" 
              height="16" 
              fill="#8C8279"
            />
            
            {/* Pièce droite haute (beige) */}
            <rect 
              x="1" 
              y="-8" 
              width="8" 
              height="8" 
              fill="#8C8279"
            />
            
            {/* Pièce droite basse (turquoise) */}
            <rect 
              x="1" 
              y="1" 
              width="8" 
              height="8" 
              fill="#40C1AC"
            />
          </g>
        </svg>
      </div>
      
      {/* Texte So-nesting */}
      {showText && (
        <span className={`font-bold text-so-beige-dark ${textSizeClasses[size]}`}>
          So-nesting
        </span>
      )}
    </div>
  );
};

export default SoNestingLogo;
